var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.14292 8.04407L2.72616 14.2746C2.41668 14.5751 1.91495 14.5751 1.60551 14.2746L0.857098 13.5479C0.548152 13.248 0.547558 12.7618 0.855777 12.4611L5.94118 7.49998L0.855777 2.53892C0.547558 2.23823 0.548152 1.75205 0.857098 1.45207L1.60551 0.725371C1.91498 0.424876 2.41672 0.424876 2.72616 0.725371L9.14289 6.95593C9.45236 7.25639 9.45236 7.74357 9.14292 8.04407Z",
    fill: "#E13A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecha);
export default __webpack_public_path__ + "static/media/Flecha.c8f4b86d79b9e7344e33bb25efa93572.svg";
export { ForwardRef as ReactComponent };